import React, { lazy } from 'react';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center overflow-hidden bg-beige" data-id="element-87">
      {/* Subtle background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-beige-light via-beige to-beige-dark opacity-50" data-id="element-88" />

      <div className="container mx-auto px-6 md:px-12 lg:px-24 relative z-10 py-20" data-id="element-89">
        <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-24" data-id="element-90">
          {/* Text Content */}
          <div className="w-full lg:w-1/2 flex flex-col items-start text-left" data-id="element-91">
            <FadeIn delay={0.1} data-id="element-92">
              <div className="w-16 h-[1px] bg-gold mb-8" data-id="element-93" />
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-94">
              <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl text-charcoal leading-tight mb-6 text-balance" data-id="element-95">
                Así como heredaste el color de tus ojos… <br data-id="element-96" />
                <span className="italic text-gold-dark" data-id="element-97">
                  también heredaste tus bloqueos emocionales.
                </span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-98">
              <p className="font-body text-lg md:text-xl text-charcoal/80 mb-10 max-w-xl leading-relaxed" data-id="element-99">
                Descubre por qué repites patrones que no comenzaron contigo — y
                cómo liberarte de ellos para siempre.
              </p>
            </FadeIn>

            <FadeIn delay={0.6} data-id="element-100">
              <Button href="#pricing" size="lg" className="w-full sm:w-auto" data-id="element-101">
                Quiero descubrir qué estoy cargando →
              </Button>
            </FadeIn>
          </div>

          {/* Image */}
          <div className="w-full lg:w-1/2 relative" data-id="element-102">
            <FadeIn delay={0.4} direction="left" duration={1.2} data-id="element-103">
              <div className="relative rounded-t-full overflow-hidden aspect-[4/5] max-w-md mx-auto shadow-2xl" data-id="element-104">
                <div className="absolute inset-0 bg-charcoal/10 mix-blend-multiply z-10" data-id="element-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-beige via-transparent to-transparent z-20" data-id="element-106" />
                <img src="https://cdn.magicpatterns.com/uploads/3FPdQbQXEJiesHPjwLAhoE/39dd6d05-e3fc-4fa2-be9f-f41370fff4ac.png" alt="Mujer mirándose al espejo con reflexión emocional" className="w-full h-full object-cover" loading="lazy" data-id="element-107" />
              </div>
              {/* Decorative elements */}
              <div className="absolute -bottom-6 -right-6 w-32 h-32 border border-gold/30 rounded-full -z-10" data-id="element-108" />
              <div className="absolute top-1/4 -left-8 w-16 h-16 border border-sage/40 rounded-full -z-10" data-id="element-109" />
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}